import { render, staticRenderFns } from "./AddCatchup.vue?vue&type=template&id=8e08d188&scoped=true"
import script from "./AddCatchup.vue?vue&type=script&lang=js"
export * from "./AddCatchup.vue?vue&type=script&lang=js"
import style0 from "./AddCatchup.vue?vue&type=style&index=0&id=8e08d188&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e08d188",
  null
  
)

export default component.exports